import { useEffect, useState } from 'react';
import { normalizeCmsDeck, getSlides } from 'services/slideDeckService';
import { fetchCmsDeckById } from 'services/cmsService';
import localDeck from 'data/deck.json';
import demoDeck from 'data/demoDeck.json';

function getParam(name) {
  const u = new URL(window.location.href);
  return u.searchParams.get(name);
}

export default function useDeckLoader({ idFromRoute } = {}) {
  const [deck, setDeck] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const mode = getParam('mode');
        const idQuery = getParam('id');
        const id = idFromRoute || idQuery;
        let deckData;

        if (mode === 'local') {
          deckData = normalizeCmsDeck(localDeck);
        } else if (id) {
          const raw = await fetchCmsDeckById(id);
          deckData = normalizeCmsDeck(raw);
        } else {
          deckData = normalizeCmsDeck(demoDeck);
        }

        if (deckData) {
            const slides = getSlides(deckData.slides);
            const finalDeck = { ...deckData, slides };
            if (mounted) {
                setDeck(finalDeck);
            }
        }

      } catch (e) {
        if (mounted) setError(e.message || 'Load error');
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [idFromRoute]);

  return { deck, loading, error };
}
